import { useRestaurantSettings } from '../../../hooks/useRestaurantSettings';
import { formatTelHref } from '../../../helpers/phone';
import InlineText from '../../InlineEdit/InlineText';
import InlineTextArea from '../../InlineEdit/InlineTextArea';
import './BackCta.scss';

const DEFAULTS = {
  eyebrow: 'Réserver une table',
  heading: 'Composez pour réserver, on vous garde la table qui convient.',
  description: 'Permanence téléphonique du mardi au samedi, de 10h à 19h.',
};

const View = (props: any) => {
  const { data, isEditMode, block, onChangeBlock } = props;
  const settings = useRestaurantSettings();

  const update = (field: string, value: string) =>
    onChangeBlock(block, { ...data, [field]: value });

  const eyebrow = data.eyebrow ?? (isEditMode ? '' : DEFAULTS.eyebrow);
  const heading = data.heading ?? (isEditMode ? '' : DEFAULTS.heading);
  const description =
    data.description ?? (isEditMode ? '' : DEFAULTS.description);

  return (
    <section className="back-cta">
      <div className="shell">
        <div className="back-cta-inner">
          <div className="back-cta-copy">
            {isEditMode ? (
              <p className="eyebrow">
                <InlineText
                  value={eyebrow}
                  onChange={(v) => update('eyebrow', v)}
                  renderTag="span"
                  placeholder="Sur-titre"
                />
              </p>
            ) : (
              eyebrow && <p className="eyebrow">{eyebrow}</p>
            )}
            {isEditMode ? (
              <h2>
                <InlineText
                  value={heading}
                  onChange={(v) => update('heading', v)}
                  renderTag="span"
                  placeholder="Titre de l’appel à réserver"
                />
              </h2>
            ) : (
              heading && <h2>{heading}</h2>
            )}
            {isEditMode ? (
              <InlineTextArea
                value={description}
                onChange={(v) => update('description', v)}
                renderTag="p"
                placeholder="Petite phrase rassurante (horaires, joignabilité…)"
              />
            ) : (
              description && <p>{description}</p>
            )}
          </div>
          <div className="back-cta-actions">
            {settings.phone_primary && (
              <a
                className="btn btn-primary"
                href={formatTelHref(settings.phone_primary)}
              >
                {settings.phone_primary}
              </a>
            )}
            {settings.phone_secondary && (
              <a
                className="btn btn-secondary"
                href={formatTelHref(settings.phone_secondary)}
              >
                {settings.phone_secondary}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default View;
